import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
    name: 'global',
    store() {
        return {
            isMobileMenuVisible: false,
            isMinicartVisible: false,
            openFilters: false,
            // isPredictiveSearchVisible: false,
            isWindowScrolled: false,
            cart: null,
            cart_count: 0,
            body: "",
            scrollTopLock: 0,
            showPasswordReset: false,
            filtersOpen: window.innerWidth < 1000 ? false : true,

            init() {
                window.liquidAjaxCart.conf("updateOnWindowFocus", false);
                window.liquidAjaxCart.conf("quantityTagAllowZero", true);

                window.addEventListener('scroll', this.onWindowScrollHandler.bind(this));

                const cartOpen = new URLSearchParams(window.location.search).get('open');

                if(cartOpen == 'true') {
                    this.isMinicartVisible = true;
                }

                if(window.location.href.indexOf("#recover") != -1) {
                    this.showPasswordReset = true;
                }

                this.initLiquidAJaxCart();

                this.body = document.querySelector("body");

                // setTimeout(() => {
                //     console.log(this.cart_count);
                //     console.log(this.cart);
                // }, 1000);

                let textItems = document.querySelectorAll('[data-lists-tables]');
                textItems.forEach(item => {
                    let lists = item.querySelectorAll('ul, ol');
                    lists.forEach(list => {
                        list.querySelectorAll('li').forEach(li => {                            
                            // Split text at | and use flex justify-between
                            const text = li.textContent.trim();
                            if (text.includes('|')) {
                                const parts = text.split('|').map(part => part.trim());
                                li.innerHTML = `<span>${parts[0]}</span><span>${parts[1]}</span>`;
                            }
                        });
                    });
                });
            },

            get bodyClasses() {
                let classes = []

                if (this.isMobileMenuVisible) {
                    classes.push('mobile-menu-visible')
                }
                if (this.isMinicartVisible) {
                    classes.push('cart-visible')
                }
                return classes || ''
            },

            openMobileMenu() {
                this.isMobileMenuVisible = true
                this.enableBodyScrollLock()
            },

            closeMobileMenu() {
                this.isMobileMenuVisible = false
                this.disableBodyScrollLock()
            },

            toggleMobileMenu() {
                this.isMobileMenuVisible = !this.isMobileMenuVisible

                if(this.isMobileMenuVisible) {
                    this.enableBodyScrollLock()
                } else {
                    this.disableBodyScrollLock()
                }
            },

            // initLiquidAJaxCart() {
            //     document.addEventListener("liquid-ajax-cart:init", (event) => {
            //         this.cart = window.liquidAjaxCart.cart;
            //     });

            //     document.addEventListener("liquid-ajax-cart:request-end", (event) => {
            //         const { requestState, cart, previousCart, sections } = event.detail;

            //         if (requestState.requestType === 'add') {
            //             if (requestState.responseData?.ok) {
            //                 this.isMinicartVisible = true;
            //                 this.enableBodyScrollLock();
            //             }
            //         }
            //         this.cart = cart
            //         this.cart_count = this.cart.item_count
            //     });
            // },

            initLiquidAJaxCart() {
                // document.addEventListener("liquid-ajax-cart:init", (event) => {
                //     this.cart = window.liquidAjaxCart.cart;
                // });
                
                // document.addEventListener("liquid-ajax-cart:request-end", (event) => {
                //     setTimeout(() => {
                //         const { requestState, cart, previousCart, sections } = event.detail;
    
                //         if (requestState.requestType === 'add') {
                //             if (requestState.responseData?.ok) {
                //                 // this.isMinicartVisible = true;
                //                 // this.enableBodyScrollLock();
                //             }
                //         }
                //         console.log(cart);
                //         this.cart = cart;
                //         console.log(this.cart);
                //         this.cart_count = this.cart.item_count
                //     }, 1000);

                // });

                document.addEventListener("liquid-ajax-cart:init", (event) => {
                    this.cart = window.liquidAjaxCart.cart;
                });

                document.addEventListener("liquid-ajax-cart:request-end", (event) => {
                    const { requestState, cart, previousCart, sections } = event.detail;

                    if (requestState.requestType === 'add') {
                        if (requestState.responseData?.ok) {
                            this.isMinicartVisible = true;
                            this.enableBodyScrollLock();
                        }
                    }

                    this.cart = cart
                    this.cart_count = this.cart.item_count
                });
            },

            onWindowScrollHandler() {
                const isScrolled = window.scrollY > 0

                this.isWindowScrolled = isScrolled
                document.body.classList[isScrolled ? 'add' : 'remove']('scrolled')
            },

            enableBodyScrollLock() {
                this.scrollTopLock =
                    document.documentElement.scrollTop || document.body.scrollTop;
                this.body.style.overflow = "hidden";
                this.body.style.position = "fixed";
                this.body.style.top = `-${this.scrollTopLock}px`;
                this.body.style.width = "100%";
            },
        
            disableBodyScrollLock() {
                this.body.style.removeProperty("overflow");
                this.body.style.removeProperty("position");
                this.body.style.removeProperty("top");
                this.body.style.removeProperty("width");
                window.scrollTo(0, this.scrollTopLock);
            },

            changeCart(id, qty = 1) {
                const body = {
                  id: id,
                  quantity: Number(qty)
                }
                
                const options = {
                  firstCallback: function(requestState) {
                    /**
                     * This callback function will be called first after the request is performed,
                     * thus none of request subscribers knows the result of the request,
                     * thus Cart state is not updated yet, sections are not updated yet,
                     * everything is not updated yet.
                     */
                  },
                  lastCallback: function(requestState) {
                    /**
                     * This callback-function will be called the latest
                     * among request subscribers,
                     * thus all the request subscribers are executed,
                     * thus Cart state is updated, sections are updated,
                     * everything is updated.
                     */
                  },
                  info: {
                    /**
                     * Any additional data you want to attach to the Request state object.
                     * Don't use the "initiator" and the "cancel" keys.
                     */
                    // myParameter: 'value'
                  },
                
                  // whether the request should go to the beginning of the queue rather than to the end
                  important: false
                }
                
                liquidAjaxCart.change(body, options);
            },

            calcCartHeight(el) {
                setTimeout(() => {
                    let cart = document.querySelector('[data-ajax-cart-section]');
                    let title = cart.querySelector('[data-title]');
                    let details = cart.querySelector('[data-details]');
    
                    let titleHeight = title.getBoundingClientRect().height;
                    let detailsHeight = details.getBoundingClientRect().height;
                    let total = titleHeight + detailsHeight
                    if(window.innerWidth < 768) {
                        total += 125;
                    } else {
                        total += 100;
                    }

                    el.style.maxHeight = `calc(100svh - ${total}px)`;
                }, 100);
            }
        }
    }
}